import { css, SerializedStyles } from '@emotion/core'
import parse from 'html-react-parser'
import React from 'react'

import { breakpoints } from '../constants/breakPoints'
import Image from './Image'

interface BadgesBlockProps {
  heading?: string
  subtitle?: string
  cssStyles?: SerializedStyles
}

const BadgesBlock: React.FunctionComponent<BadgesBlockProps> = ({ heading, subtitle, cssStyles = css`` }) => {
  return (
    <div css={[containerStyle(subtitle), cssStyles]}>
      {heading && <h2 className={'heading2 center'}>{parse(heading)}</h2>}
      {subtitle && <div className={'subtitle center'}>{parse(subtitle)}</div>}
      <div css={badgesContainerStyle}>
        <Image src={'badges/crozdesk-quality-choice.webp'} alt={'crozdesk quality choice'} />
        <Image src={'badges/proddy.webp'} alt={'proddy roadmapping'} />
        <Image src={'badges/g2-users-love-us.webp'} alt={'g2 badge users love us'} />
        <Image src={'badges/g2-leader-winter.webp'} alt={'g2 badge leader winter 2025'} />
        <Image src={'badges/g2-best-support-winter.webp'} alt={'g2 badge best support mid-market winter 2025'} />
        <Image src={'badges/capterra-shortlist.webp'} alt={'capterra badge shortlist'} css={badgeStyle} />
        <Image src={'badges/get-app.webp'} alt={'get app badge'} css={badgeStyle} />
      </div>
    </div>
  )
}

export default BadgesBlock

const containerStyle = (subtitle?: string) => css`
  .heading2 {
    ${subtitle && 'margin-bottom: 0 !important'};
    @media screen and (max-width: ${breakpoints.small}px) {
      text-align: center !important;
    }
  }
  .subtitle {
    margin-bottom: 2.5rem !important;
  }
`

const badgesContainerStyle = css`
  margin-top: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .gatsby-image-wrapper {
    width: 7rem;
    @media screen and (max-width: ${breakpoints.large}px) {
      width: 5rem;
    }
    @media screen and (max-width: ${breakpoints.medium}px) {
      width: 4rem;
    }
  }
`

const badgeStyle = css`
  width: 8rem !important;

  @media screen and (max-width: ${breakpoints.large}px) {
    width: 6rem !important;
  }
  @media screen and (max-width: ${breakpoints.medium}px) {
    width: 5rem !important;
  }
`
